// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.landing-opening {
  min-width: 100%;
  min-height: 100vh;
  height: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: left;
}

.landing-opening > svg {
  display: block;
  width: calc(490px * 0.85);
  height: calc(637px * 0.85);
}

.landing-opening > h1 {
  margin: 0px;
  color: #116466;
}

.landing-opening > p {
  width: 729px;
  text-align: center;
}

p > a {
  color: inherit; /* Resets color to the parent's color */
  text-decoration: none; /* Removes underline */
  font-weight: normal; /* Resets boldness */
  /* Add any other properties you want to reset or change */
}

.scroll-down-button-icon {
  cursor: pointer;
  margin-top: 50px;
  fill: #116466;
  width: 60px;
  height: 60px;
  padding: 10px;
  border-radius: 50px;
  background-color: #1F1F1F; 
  -webkit-box-shadow: -7px 6px 14px 1px rgba(0,0,0,0.39);
  -moz-box-shadow: -7px 6px 14px 1px rgba(0,0,0,0.39);
  box-shadow: -7px 6px 14px 1px rgba(0,0,0,0.39);
}

.npx {
  font-family: "monospace";
  border: 1px solid #ccc; /* Light grey border */
  border-radius: 10px; /* Rounded corners */
  padding: 15px; /* Some padding inside the box */
  box-shadow: 0 2px 5px rgba(0,0,0,0.2); /* Optional: Adds a shadow for depth */
  background-color: white; /* Background color */
  /* Add any other styles you wish here */
}

.npx > p {
  margin: 0px;
}

.scroll-up-button-icon {
  cursor: pointer;
  margin-top: 50px;
  fill: #116466;
  width: 60px;
  height: 60px;
  padding: 10px;
  border-radius: 50px;
  background-color: #1F1F1F; 
  -webkit-box-shadow: -7px 6px 14px 1px rgba(0,0,0,0.39);
  -moz-box-shadow: -7px 6px 14px 1px rgba(0,0,0,0.39);
  box-shadow: -7px 6px 14px 1px rgba(0,0,0,0.39);
}

@media (max-width: 1360px) {
  .landing-opening > p {
    max-width: calc(100% - 40px);
    margin-left: 20px;
    margin-right: 20px;
    overflow-wrap: normal;
    word-break: normal;
  }
}

/* Responsive styles for smaller screens */
@media (max-width: 768px) {
  .landing-opening > img {
    width: calc(100% - 40px);
    height: 250px;
    margin-left: 20px;
    margin-right: 20px;
  }

  .landing-opening > h1 {
    width: calc(100% - 40px);
    text-align: center;
    margin-left: 20px;
    margin-right: 20px;
  }

  .landing-opening > p {
    width: calc(100% - 40px);
    margin-left: 20px;
    margin-right: 20px;
    overflow-wrap: normal;
    word-break: normal;
  }
}`, "",{"version":3,"sources":["webpack://./src/client/routes/Home.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,cAAc,EAAE,uCAAuC;EACvD,qBAAqB,EAAE,sBAAsB;EAC7C,mBAAmB,EAAE,oBAAoB;EACzC,yDAAyD;AAC3D;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,sDAAsD;EACtD,mDAAmD;EACnD,8CAA8C;AAChD;;AAEA;EACE,wBAAwB;EACxB,sBAAsB,EAAE,sBAAsB;EAC9C,mBAAmB,EAAE,oBAAoB;EACzC,aAAa,EAAE,gCAAgC;EAC/C,qCAAqC,EAAE,sCAAsC;EAC7E,uBAAuB,EAAE,qBAAqB;EAC9C,uCAAuC;AACzC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,sDAAsD;EACtD,mDAAmD;EACnD,8CAA8C;AAChD;;AAEA;EACE;IACE,4BAA4B;IAC5B,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;IACrB,kBAAkB;EACpB;AACF;;AAEA,0CAA0C;AAC1C;EACE;IACE,wBAAwB;IACxB,aAAa;IACb,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,wBAAwB;IACxB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,wBAAwB;IACxB,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;IACrB,kBAAkB;EACpB;AACF","sourcesContent":[".landing-opening {\n  min-width: 100%;\n  min-height: 100vh;\n  height: auto;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  text-align: left;\n}\n\n.landing-opening > svg {\n  display: block;\n  width: calc(490px * 0.85);\n  height: calc(637px * 0.85);\n}\n\n.landing-opening > h1 {\n  margin: 0px;\n  color: #116466;\n}\n\n.landing-opening > p {\n  width: 729px;\n  text-align: center;\n}\n\np > a {\n  color: inherit; /* Resets color to the parent's color */\n  text-decoration: none; /* Removes underline */\n  font-weight: normal; /* Resets boldness */\n  /* Add any other properties you want to reset or change */\n}\n\n.scroll-down-button-icon {\n  cursor: pointer;\n  margin-top: 50px;\n  fill: #116466;\n  width: 60px;\n  height: 60px;\n  padding: 10px;\n  border-radius: 50px;\n  background-color: #1F1F1F; \n  -webkit-box-shadow: -7px 6px 14px 1px rgba(0,0,0,0.39);\n  -moz-box-shadow: -7px 6px 14px 1px rgba(0,0,0,0.39);\n  box-shadow: -7px 6px 14px 1px rgba(0,0,0,0.39);\n}\n\n.npx {\n  font-family: \"monospace\";\n  border: 1px solid #ccc; /* Light grey border */\n  border-radius: 10px; /* Rounded corners */\n  padding: 15px; /* Some padding inside the box */\n  box-shadow: 0 2px 5px rgba(0,0,0,0.2); /* Optional: Adds a shadow for depth */\n  background-color: white; /* Background color */\n  /* Add any other styles you wish here */\n}\n\n.npx > p {\n  margin: 0px;\n}\n\n.scroll-up-button-icon {\n  cursor: pointer;\n  margin-top: 50px;\n  fill: #116466;\n  width: 60px;\n  height: 60px;\n  padding: 10px;\n  border-radius: 50px;\n  background-color: #1F1F1F; \n  -webkit-box-shadow: -7px 6px 14px 1px rgba(0,0,0,0.39);\n  -moz-box-shadow: -7px 6px 14px 1px rgba(0,0,0,0.39);\n  box-shadow: -7px 6px 14px 1px rgba(0,0,0,0.39);\n}\n\n@media (max-width: 1360px) {\n  .landing-opening > p {\n    max-width: calc(100% - 40px);\n    margin-left: 20px;\n    margin-right: 20px;\n    overflow-wrap: normal;\n    word-break: normal;\n  }\n}\n\n/* Responsive styles for smaller screens */\n@media (max-width: 768px) {\n  .landing-opening > img {\n    width: calc(100% - 40px);\n    height: 250px;\n    margin-left: 20px;\n    margin-right: 20px;\n  }\n\n  .landing-opening > h1 {\n    width: calc(100% - 40px);\n    text-align: center;\n    margin-left: 20px;\n    margin-right: 20px;\n  }\n\n  .landing-opening > p {\n    width: calc(100% - 40px);\n    margin-left: 20px;\n    margin-right: 20px;\n    overflow-wrap: normal;\n    word-break: normal;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
